import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { Field } from 'react-final-form';

import Deposit from '../../../../assets/icons/deposit.svg';
import Success from '../../../../assets/icons/success.svg';
import Withdraw from '../../../../assets/icons/withdraw.svg';
import type { HelpSection } from '../../../../types/Cashier';
import { PaymentVerificationTypes } from '../../../../types/Cashier';
import ButtonGroup from '../../../ButtonGroup/ButtonGroup';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import HelpSectionContent from '../HelpSectionContent/HelpSectionContent';

import {
  TXTWCL_This_helps_us_authenticate_you_ELL,
  TXTWCL_Verify,
  TXTWCL_Verify_your_payment_method,
  TXTWCL_Why_verify_your_payment_method_ELL,
  TXTWCL_You_can_deposit_as_many_times__ELL,
  TXTWCL_You_can_deposit_immediately_on_ELL,
  TXTWCL_You_can_withdraw_with_your_ver_ELL
} from './PaymentVerificationMenu.messages.json';
import { content, wrapper } from './PaymentVerificationMenu.scss';

const helpSection: HelpSection = {
  title: TXTWCL_Why_verify_your_payment_method_ELL,
  body: <HelpSectionContent />
};

const PaymentVerificationMenu: React.FC = () => (
  <Container
    headerProps={{
      title: <Translation {...TXTWCL_Verify_your_payment_method} />,
      buttons: { back: false }
    }}
    page={PaymentVerificationMenu}
    helpSupportResolver
    showFooter
    pageTopTitle={<Translation {...TXTWCL_Verify_your_payment_method} />}
    pageTopSubtitle={<Translation {...TXTWCL_This_helps_us_authenticate_you_ELL} />}
    helpSection={helpSection}
  >
    <div className={wrapper}>
      <p className={content}>
        <Success />
        <Translation {...TXTWCL_You_can_deposit_immediately_on_ELL} />
      </p>
      <p className={content}>
        <Deposit />
        <Translation {...TXTWCL_You_can_deposit_as_many_times__ELL} />
      </p>
      <p className={content}>
        <Withdraw />
        <Translation {...TXTWCL_You_can_withdraw_with_your_ver_ELL} />
      </p>
    </div>
    <div>
      <Field name={'paymentVerification.menuSelected'}>
        {({ input: { onChange } }) => (
          <ButtonGroup>
            <CTAButton
              onClick={() => onChange(PaymentVerificationTypes.verify)}
              translation={TXTWCL_Verify}
            />
          </ButtonGroup>
        )}
      </Field>
    </div>
  </Container>
);

PaymentVerificationMenu.displayName = 'PaymentVerificationMenu';

export default PaymentVerificationMenu;
